export const capitalizeFirstLetter = (str: string): string => {
  if (str.length === 0) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const convertCSVtoArray = (
  input: string,
  separator: string = ',',
): string[] => {
  return input
    .split(separator)
    .map((item) => item.trim())
    .filter((item) => item !== '');
};
